import { useMutation } from 'react-query';
import { useForm } from 'react-hook-form';

import { changePasswordService } from 'services/auth';

import PasswordInput from '@core/components/passwordinput/PasswordInput';
import TextInput from '@core/components/textinput/TextInput';
import UseToast from 'hooks/use-toast';
import ActionButton from '@core/components/actionbutton/ActionButton';

import ChangePasswordIcon from 'assets/icons/change-password-icon.svg';

import classes from './PasswordSection.module.scss';

const PasswordSection = ({ callback = undefined }) => {
	const { ToastContainer, toast } = UseToast();
	const { mutate, isLoading } = useMutation(changePasswordService, {
		onSuccess: () => {
			toast('Password has been changed.');
			reset();
			callback && callback();
		},
		onError: (err) => {
			const msg = err.response.data.data.old_password[0];
			setError('old_password', { type: 'custom', message: msg });
		}
	});

	const {
		register,
		setError,
		handleSubmit,
		reset,
		formState: { errors, isDirty, isValid }
	} = useForm({ mode: 'onChange' });

	const submit = (payload) => {
		mutate(payload);
	};

	return (
		<>
			<ToastContainer />
			<form onSubmit={handleSubmit(submit)} className={classes['form-container']}>
				<h1>
					<ChangePasswordIcon />
					Change password
				</h1>
				<TextInput
					validation={{
						required: true
					}}
					input={{
						type: 'password',
						label: 'Current Password',
						id: 'current_password',
						name: 'old_password'
					}}
					kind="custom"
					errors={errors}
					register={register}></TextInput>
				<PasswordInput
					validation={{
						required: true
					}}
					input={{
						label: 'New Password',
						id: 'new_password',
						name: 'password'
					}}
					errors={errors}
					register={register}></PasswordInput>
				<ActionButton
					type="submit"
					disabled={!isDirty || !isValid || isLoading}
					loading={isLoading}>
					Change password
				</ActionButton>
			</form>
		</>
	);
};

export default PasswordSection;
